import React from "react"
import {
    AddIcon,
    Button,
    Checkbox,
    Dropdown,
    Flex,
    Input,
    Text,
    TextArea
} from "@fluentui/react-northstar"
import {
    ICheckboxData,
    IFeedbackFormData
} from "./Types"
import CheckboxForm from "./CheckboxForm"

export interface IFeedbackFormProps {
    feedbackForm: IFeedbackFormData;
    titleChanged: any;
    subtitleChanged: any;
    imageLinkChanged: any;
    summaryChanged: any;
    requireCommentsChange: any;
    selectedFeedbackTypeChange:any;
    addCheckbox: any;
    checkboxTitleChanged: any;
    deleteCheckbox: any;
}

export default function FeedbackForm(props: IFeedbackFormProps) {
    return (
        <Flex className="scrollableContent">
            <Flex.Item size="size.half">
                <Flex column className="formContentContainer">
                    <h3>Feedback</h3>

                    <Input className="inputField"
                        value={props.feedbackForm.title}
                        label="Titulo"
                        placeholder="Titulo"
                        onChange={props.titleChanged}
                        autoComplete="off"
                        fluid
                    />

                    <Input className="inputField"
                        value={props.feedbackForm.subtitle}
                        label="Subtitulo"
                        placeholder="Subtitulo"
                        onChange={props.subtitleChanged}
                        autoComplete="off"
                        fluid
                    />

                    <Input fluid className="inputField"
                        value={props.feedbackForm.imageLink}
                        label="URL de la imagen"
                        placeholder="URL de la imagen"
                        onChange={props.imageLinkChanged}
                        // error={!(props.feedbackForm.errorImageUrlMessage === "")}
                        autoComplete="off"
                    />
                    {/* <Text className={(props.feedbackForm.errorImageUrlMessage === "") ? "hide" : "show"} error size="small" content={props.feedbackForm.errorImageUrlMessage} /> */}

                    <div className="textArea">
                        <Text content="Resumen" />
                        <TextArea
                            autoFocus
                            placeholder="Resumen"
                            value={props.feedbackForm.summary}
                            onChange={props.summaryChanged}
                            fluid />
                    </div>

                    <Checkbox className="checkbox" label="Habilitar comentarios"
                        onChange={props.requireCommentsChange}
                        checked={props.feedbackForm.requireComments}
                        toggle />

                    <Text content="Seleccione tipo de feedback" />
                    <Dropdown
                        items={props.feedbackForm.feedbackType}
                        value={props.feedbackForm.selectedFeedbackType}
                        getA11ySelectionMessage={{ onAdd: item => props.selectedFeedbackTypeChange(item) }}
                    />

                    <Button className="inputButton"
                        icon={<AddIcon />}
                        content="Nuevo checkbox"
                        title="Add" 
                        onClick={() => props.addCheckbox()}
                    />
                    {
                        props.feedbackForm.checkboxes.map((checkbox: ICheckboxData) => (
                            <CheckboxForm checkbox={checkbox}
                                checkboxTitleChanged={props.checkboxTitleChanged}
                                deleteCheckboxClick={props.deleteCheckbox} />
                        ))
                    }
                </Flex>
            </Flex.Item>
            <Flex.Item size="size.half">
                <div className="adaptiveCardContainer">
                </div>
            </Flex.Item>
        </Flex>
    )
}
